import {
  Badge,
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  CardTitle,
  Col,
  Row,
} from 'reactstrap';
import { BankingOffer } from '../models/preQualificationModel';
import {
  IconBuildingBank,
  IconClock,
  IconCurrencyDollar,
  IconPercentage,
} from '@tabler/icons-react';
import { PreQualificationResultStatusBadge } from './PreQualificationStatusBadge';
import { PreQualificationResultStatus } from '../enums/PreQualificationEnum';
import PreQualificationDetailBankRulesModal from './PreQualificationDetailBankRulesModal';
import PreQualificationDetailBankLogActionModal from './PreQualificationDetailBankLogActionModal';

interface Props {
  offer: BankingOffer;
}

const PreQualifcationDetailBankOption = ({ offer }: Props) => {
  const {
    int_rate,
    loan_amount,
    loan_term,
    logo,
    name,
    rejection_reasons,
    status,
    rules_result,
    tags,
    log_actions,
  } = offer;

  return (
    <Card className="mb-3 shadow">
      <CardHeader className="bg-light">
        <div className="d-flex justify-content-between align-items-center">
          <div className="d-flex align-items-center">
            <IconBuildingBank size={20} className="text-primary me-2" />
            <CardTitle tag="h5" className="mb-0">
              {name}
            </CardTitle>
          </div>
          <PreQualificationResultStatusBadge
            status={status as PreQualificationResultStatus}
          />
        </div>
      </CardHeader>

      <CardBody>
        <Row className="mb-3">
          <Col md={4}>
            <div className="d-flex align-items-center">
              <IconCurrencyDollar size={16} className="text-primary me-2" />
              <div>
                <small className="text-muted">Monto máximo a solicitar</small>
                <div className="fw-bold fs-5">{loan_amount}</div>
              </div>
            </div>
          </Col>

          <Col md={4}>
            <div className="d-flex align-items-center">
              <IconPercentage size={16} className="text-primary me-2" />
              <div>
                <small className="text-muted">Intereses</small>
                <div className="fw-bold fs-5">{int_rate}</div>
              </div>
            </div>
          </Col>
          <Col md={4}>
            <div className="d-flex align-items-center">
              <IconClock size={16} className="text-primary me-2" />
              <div>
                <small className="text-muted">Plazo</small>
                <div className="fw-bold">{loan_term}</div>
              </div>
            </div>
          </Col>
        </Row>

        {rejection_reasons.length > 0 && (
          <div>
            <small className="text-muted">Reglas fallidas</small>
            <div className="mt-2">
              {rejection_reasons.map((condition, index) => (
                <Badge key={index} color="warning" className="me-1 mb-1">
                  {condition}
                </Badge>
              ))}
            </div>
          </div>
        )}
        {rejection_reasons.length === 0 && (
          <div>
            <small className="text-muted">Reglas fallidas</small>
            <div className="mt-2">
              <Badge color="info" className="me-1 mb-1">
                N/A
              </Badge>
            </div>
          </div>
        )}
      </CardBody>
      <CardFooter>
        {rules_result && rules_result.length > 0 && (
          <PreQualificationDetailBankRulesModal rules_result={rules_result} />
        )}
        <PreQualificationDetailBankLogActionModal log_actions={log_actions} />
      </CardFooter>
    </Card>
  );
};

export default PreQualifcationDetailBankOption;
